// Module
var code = "<div ng-repeat=\"(k, context) in $ctrl.contexts\"> <note-context ng-disabled=\"$ctrl.disabled\" ng-model=\"context\" on-delete=\"$ctrl.deleteContext(k)\"></note-context> </div> <note-context ng-if=\"!$ctrl.disabled\" ng-model=\"$ctrl.tmpContext\" opened=\"$ctrl.tmpOpened\"></note-context> ";
// Exports
export default code;